"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

const urlBackendPath = "/me/pin/verify" as const;

export const useRequestMePinVerifyPost = (
  props: Partial<UseOpenApiMutationOptions<typeof urlBackendPath, "POST">> = {},
) =>
  useOpenApiMutation({
    method: "POST",
    urlBackendPath,
    ...props,
  });
